import React from 'react';
import { ChatApiClientProvider } from './ChatApiClientContext.jsx';
import { ChatWebSocketServiceProvider } from './ChatWebSocketServiceContext.jsx';
import { ChatNotificationsProvider } from './ChatNotificationsContext.jsx';
import { HomeChatProviderShell } from './ChatProviderShell.jsx';

/**
 * Host-facing provider: injects `apiClient`, optional WebSocket facade and notifications,
 * then mounts the legacy Home chat shell (orchestrators + split context).
 *
 * @param {object} props
 * @param {import('react').ReactNode} props.children
 * @param {string} props.userId
 * @param {string} props.tenantId
 * @param {import('axios').AxiosInstance} props.apiClient
 * @param {object|null} [props.wsService] - Same interface as ann-web-app `websocketService` for `scope:CONVERSATION` events
 * @param {{ success?: Function, error?: Function }|null} [props.notifications] - Optional toast API (`useToast` shape)
 * @param {object|null} [props.authStore] - Store shape expected by `useContextOrchestrator` (userData, userId, currentWorkspaceUuid, …)
 * @param {object|null} [props.auth0User] - User profile for display name in context payload (optional; same role as Auth0 `user` in legacy)
 */
export function ChatProviderWrapper({
  children,
  userId,
  tenantId,
  apiClient,
  wsService = null,
  notifications = null,
  authStore = null,
  auth0User = null,
}) {
  return (
    <ChatApiClientProvider client={apiClient}>
      <ChatWebSocketServiceProvider service={wsService}>
        <ChatNotificationsProvider value={notifications}>
          <HomeChatProviderShell
            userId={userId}
            tenantId={tenantId}
            authStore={authStore}
            auth0User={auth0User}
          >
            {children}
          </HomeChatProviderShell>
        </ChatNotificationsProvider>
      </ChatWebSocketServiceProvider>
    </ChatApiClientProvider>
  );
}
